import { css } from '@emotion/react';

import {
  CommerceIconsSet,
  InitialLoadIconsSet,
  LikeDislikeIconsSet,
  NewIconsSet,
  OtherIconsSet,
  PlayerIconsSet,
  Zee5PlayerIconsSet
} from 'src/utils/constants/IconsConstants';
import {
  notasansRegular,
  notasansMedium,
  notasansBold,
  initialLoadIcons,
  otherIcons,
  newIcons,
  zee5PlayerIcons,
  playerIcons,
  likeDislikeIcons,
  commerceIcons
} from '../fonts/customFontsConfig';

export const RegularFont = `${notasansRegular.style.fontFamily}, sans-serif`;
export const MediumFont = `${notasansMedium.style.fontFamily}, sans-serif`;
export const BoldFont = `${notasansBold.style.fontFamily}, sans-serif`;
export const BaseFont = 16;

export const ZeeFont = (
  FontSize: number,
  LineHeight = FontSize,
  FontFamily = RegularFont
) => `
      font-family: ${FontFamily};
      font-size: ${FontSize / BaseFont}rem;
      line-height: ${LineHeight / BaseFont}rem;
    `;
export const SetFontSize = (FontSize: number, LineHeight = FontSize) => `
      font-size: ${FontSize / BaseFont}rem;
      line-height: ${LineHeight / BaseFont}rem;
    `;

// Regular font
export const ZeeFontRegular = (FontSize: number, LineHeight = FontSize) => `
    ${ZeeFont(FontSize, LineHeight, RegularFont)}
    font-weight: 400;
  `;

// Medium font
export const ZeeFontMedium = (FontSize: number, LineHeight = FontSize) => `
    ${ZeeFont(FontSize, LineHeight, MediumFont)}
    font-weight: 500;
  `;

// Bold font
export const ZeeFontBold = (FontSize: number, LineHeight = FontSize) => `
    ${ZeeFont(FontSize, LineHeight, BoldFont)}
    font-weight: 700;
  `;

// Icons Families
export enum IconsConstants {
  INITIAL_LOAD_ICONS = 'IconsInitialLoad',
  NEW_ICONS = 'NewIcons',
  OTHER_ICONS = 'OtherIcons',
  PLAYER_ICONS = 'PlayerIcons',
  ZEE5_PLAYER_ICONS = 'Zee5PlayerIcons',
  LIKE_DISLIKE_ICONS = 'LikeDislikeIcons',
  COMMERCE_ICONS = 'CommerceIcons'
}

/**
 * return font boiler plate code
 * @param {string} iconsFamily name of the icon family
 * @returns {string} boilerplate for family
 */
const getIcons = (iconsFamily: string) => {
  return `
      font-family: ${iconsFamily} ;
      speak: none;
      font-style: normal;
      font-variant: normal;
      text-transform: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  `;
};

/**
 * Returns Initial load icons css
 * @param {InitialLoadIconsSet} iconName Name of Icon
 * @param {boolean} isAfter (optional) is the content after or before
 * @returns css for required icons
 */
export const getInitialLoadIcons = (
  iconName: InitialLoadIconsSet,
  isAfter?: boolean
) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(initialLoadIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};

/**
 * Return Other Icons
 * @param {OtherIconsSet} iconName Name of the Icon
 * @param {boolean} isAfter (optional) is the content after or before
 * @returns css required icons
 */
export const getOtherIcons = (iconName: OtherIconsSet, isAfter?: boolean) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(otherIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};

/**
 * Return Other Icons
 * @param {NewIconsSet}iconName Name of the Icon
 * @param {boolean} isAfter (optional) is the content after or before
 * @returns css required icons
 */
export const getNewIcons = (iconName: NewIconsSet, isAfter?: boolean) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(newIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};
/**
 * Return Other Icons
 * @param {Zee5PlayerIconsSet} iconName Name of the Icon
 * @param {boolean} isAfter (optional) is the content after or before
 * @returns css required icons
 */
export const getZee5PlayerIcons = (
  iconName: Zee5PlayerIconsSet,
  isAfter?: boolean
) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(zee5PlayerIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};
/**
 * Return Other Icons
 * @param iconName Name of the Icon
 * @param {boolean} isAfter (optional) is the content after or before
 * @returns css required icons
 */
export const getPlayerIcons = (iconName: PlayerIconsSet, isAfter?: boolean) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(playerIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};

export const getLikeDislikeIcons = (
  iconName: LikeDislikeIconsSet,
  isAfter?: boolean
) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(likeDislikeIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};

export const getCommerceIcons = (
  iconName: CommerceIconsSet,
  isAfter?: boolean
) => {
  const location = isAfter ? 'after' : 'before';
  return css`
    &: ${location} {
      ${getIcons(commerceIcons.style.fontFamily)}
      content: '${iconName}';
    }
  `;
};
